import React, { useState, useRef } from "react";
import styles from "./PnSMobile.module.css";

const BASE = process.env.PUBLIC_URL + "/svg/mainMobile";

export default function PnSMobile() {
    const groups = [1, 2, 3].map((n) =>
        [1, 2, 3].map((i) => `${BASE}/chat${n}_${i}.svg`)
    );

    const [index, setIndex] = useState(0);
    const startX = useRef(0);

    const handleTouchStart = (e) => {
        startX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        const endX = e.changedTouches[0].clientX;
        const diff = startX.current - endX;

        if (diff > 50 && index < groups.length - 1) {
            setIndex((prev) => prev + 1);
        } else if (diff < -50 && index > 0) {
            setIndex((prev) => prev - 1);
        }
    };

    return (
        <div
            className={styles.carousel}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            <div className={styles.dots}>
                {groups.map((_, i) => (
                    <span
                        key={i}
                        className={`${styles.dot} ${index === i ? styles.active : ""}`}
                        onClick={() => setIndex(i)}
                    />
                ))}
            </div>

            <div
                className={styles.inner}
                style={{ transform: `translateX(-${index * 100}%)` }}
            >
                {groups.map((group, idx) => (
                    <div key={idx} className={styles.slide}>
                        <p className={styles.dateLabel}>{new Date().getFullYear()}년 08월 27일</p>
                        {group.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`chat-${idx}-${i}`}
                                className={`${styles.fadeIn} ${index === idx ? styles.activeFade : ""}`}
                                style={{ animationDelay: `${i * 1}s` }} // 순차 지연
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
